import React, { useState } from "react";
import { Button, Table, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Modals from "../Modals/Modals";
import classes from "./ValidationTable.module.scss";

const { Link } = Typography;

const ValidationTable = ({ listDocuments, getPendingCrfa, lastUserSub }) => {
  // Controla qual modal está aberto
  const [activeModal, setActiveModal] = useState(null);

  // Guarda o documento selecionado
  const [selectedDocument, setSelectedDocument] = useState(null);

  const getHeaderTableNames = (name) => {
    const names = {
      user_sub: "Sub",
      name: "Nome",
      email: "E-mail",
      document: "Documento",
    };

    return names[name] || name;
  };

  // Define as colunas que aparecem na tabela
  const selectedColumns = ["user_sub", "name", "email", "document"];

  const colums = selectedColumns.map((key) => {
    return {
      dataIndex: key,
      title: getHeaderTableNames(key),

      render: (value, record) => {
        if (key === "document") {
          return (
            <div
              // Seleciona o documento e abre o modal
              onClick={() => {
                setSelectedDocument(record);
                setActiveModal("document");
              }}
              style={{
                display: "flex",
              }}
            >
              <Link
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                Ver arquivo <SearchOutlined style={{ fontSize: 18 }} />
              </Link>
            </div>
          );
        }

        return value;
      },
    };
  });

  return (
    <>
      <Table
        className={classes.ValidationTable}
        columns={colums}
        dataSource={listDocuments}
        rowKey={(record) => record.user_sub}
        scroll={{ x: true }}
        style={{ maxWidth: "100%", marginBottom: "16px" }}
        pagination={false}
      />
      {lastUserSub && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            marginTop: "16px",
          }}
        >
          <Button
            style={{
              color: "#0d6e7a",
              border: "1px solid #0d6e7a",
              borderRadius: "11px",
            }}
            onClick={() => getPendingCrfa(true)}
          >
            Ver mais
          </Button>
        </div>
      )}

      <Modals
        setActiveModal={setActiveModal}
        activeModal={activeModal}
        selectedDocument={selectedDocument}
        getPendingCrfa={getPendingCrfa}
      />
    </>
  );
};

export default ValidationTable;
